import { generateTestId } from "@client-shared";

export const setProductThumbnailTestId = (identifier: string): string => generateTestId("ProductThumbnail", identifier);
